import React from 'react';
import PropTypes from 'prop-types';
import { cardProviders } from '../../../../../screens/Card/constants';

const MAPPING = {
  [cardProviders.MONAVATE]: (
    <svg x={15} y={155} width="14" height="6" viewBox="0 0 14 6" fill="none">
      <path
        d="M0.648828 0.230927V5.57422H4.12197V4.87196H1.42742V3.23844H3.77847V2.53618H1.42742V0.933188H4.00747V0.230927H0.648828ZM6.35553 2.93311L4.76781 5.57422H5.67617L6.8288 3.52087H6.93566L8.03485 5.57422H8.96611L7.38603 2.87204L8.92031 0.230927H8.01196L6.91276 2.29191H6.8059L5.73724 0.230927H4.81361L6.35553 2.93311ZM11.6195 0.230927H9.68829V5.57422H10.4669V3.65063H11.6195C12.6805 3.65063 13.4668 2.92547 13.4668 1.94841C13.4668 0.963722 12.6805 0.230927 11.6195 0.230927ZM10.4669 2.94837V0.933188H11.7416C12.3828 0.933188 12.6118 1.15455 12.6118 1.76522V2.11635C12.6118 2.72701 12.3828 2.94837 11.7416 2.94837H10.4669Z"
        fill="#2D2926"
      />
    </svg>
  ),
  [cardProviders.GALILEO]: (
    <svg x={15} y={160} width="14" height="6" viewBox="0 0 14 6" fill="none">
      <path
        d="M0.648828 0.230927V5.57422H4.12197V4.87196H1.42742V3.23844H3.77847V2.53618H1.42742V0.933188H4.00747V0.230927H0.648828ZM6.35553 2.93311L4.76781 5.57422H5.67617L6.8288 3.52087H6.93566L8.03485 5.57422H8.96611L7.38603 2.87204L8.92031 0.230927H8.01196L6.91276 2.29191H6.8059L5.73724 0.230927H4.81361L6.35553 2.93311ZM11.6195 0.230927H9.68829V5.57422H10.4669V3.65063H11.6195C12.6805 3.65063 13.4668 2.92547 13.4668 1.94841C13.4668 0.963722 12.6805 0.230927 11.6195 0.230927ZM10.4669 2.94837V0.933188H11.7416C12.3828 0.933188 12.6118 1.15455 12.6118 1.76522V2.11635C12.6118 2.72701 12.3828 2.94837 11.7416 2.94837H10.4669Z"
        fill="#2D2926"
      />
    </svg>
  ),
};

export const EXPLabel = ({ cardProvider = null }) => MAPPING[cardProvider] || null;

export default EXPLabel;

EXPLabel.propTypes = {
  cardProvider: PropTypes.string,
};
